
<div class="container mb-24">

    <app-banner [widthScreen]="widthScreen"></app-banner>

    <p class="container mt-7">Feature Projects</p>
    <div *ngIf="!isLoading" class="projects">
      <app-project></app-project>
    </div>
    <div class="loading" *ngIf="isLoading">
      <app-spinner></app-spinner>
  </div>
    <p class="container mt-7 text-black font-bold grid grid-cols-7">Recent Stories
        <span class="cursor-pointer">
            <img class="mt-1" src="../../../assets/nft/addficon.png" width="20" height="20" alt="">
        </span>
    </p>

    <article class="container grid  mb-4">
        <div class="isiartikel mb-8" *ngFor="let item of dataStory">
            <h2>
                {{item.title}}
            </h2>
            <p>
                {{item.subTitle}}
            </p>
            <div class="time text-sm text-gray-400">
                {{item.createdAt}}
            </div>
        </div>

    </article>
    <div class="banner-bottom container xl:w-full sm:h-max lg:h-72 lg:grid grid-cols-2 xl:grid-cols-2 sm:grid-rows-3">
        <div class="title p-5">
            <h1 class="headTitle sm:text-lg xl:text-xl">HI!,  HIRE ME ?</h1>
            <p class="sm:text-sm">
                Want to create something awesome? Or, you have any query? Drop an message.
            </p>
            <div class="button sm:grid-rows-2 sm:gap-2">
                <button (click)="openDialog()" type="button" class="inline-block px-6 py-2 bg-blue-500 active:bg-blue-500 text-white font-medium text-xs rounded focus:bg-blue-400 focus:shadow-lg">YES HIRE</button>

                <button *ngIf="role == 'admin'"  [routerLink]="['data-hire']" type="button" class="inline-block px-6 py-2 bg-green-500 active:bg-blue-500 text-white font-medium text-xs rounded focus:bg-blue-400 focus:shadow-lg">SEE Message</button>
            </div>
        </div>
        <div class="icon pl-20">
            <img src="../../../assets/nft/chatIcon.png" class="sm:w-24 md:w-32 lg:w-36 xl:w-52 " alt="">
        </div>
    </div>
</div>
